import PropTypes from "prop-types";

import FormDialog from "components/modals/FormDialog";
import CallDispositionForm from "./CallDispositionForm";

const CallDispositionModal = ({
  model,
  parentDispositions,
  open,
  onOpenChange,
  onSuccess,
}) => (
  <FormDialog
    FormComponent={CallDispositionForm}
    model={model}
    modelType="Disposition"
    formProps={{ parentDispositions }}
    open={open}
    onOpenChange={onOpenChange}
    onSuccess={onSuccess}
  />
);

CallDispositionModal.propTypes = {
  model: PropTypes.object,
  parentDispositions: PropTypes.array,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  onSuccess: PropTypes.func,
};

export default CallDispositionModal;
